import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Link } from '../components/nav'
import './NotFound.css'

// Catch-all for app URLs the router has no match for (/about, /contact-us, typos, stale links —
// QA bug bug-mu2x3qub-wtzp). Without it the AppShell <Routes> matched nothing and committed a
// permanently empty <main>: the shell rendered, every request returned 200, and no console error
// ever fired, so the page just looked broken. It renders for signed-out visitors too (no auth
// wrapper), and App.tsx imports it statically so the error path never depends on another chunk
// fetch succeeding.
export default function NotFound() {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = 'Page not found — Replay QA'
    return () => {
      document.title = 'Replay QA'
    }
  }, [])

  return (
    <div className="not-found" data-testid="not-found">
      <h1 className="not-found__heading">Page not found</h1>
      <p className="not-found__body">
        Nothing lives at <code className="not-found__path">{pathname}</code>. The link may be
        outdated or mistyped.
      </p>
      <div className="not-found__links">
        <Link to="/">Go to Dashboard</Link>
        <Link to="/projects">Go to Projects</Link>
      </div>
    </div>
  )
}
